<template>
  <Transition name="loading-bar">
    <div v-if="isLoading" class="global-loading-bar">
      <div class="global-loading-bar-indicator" />
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useUiStore } from '@/stores/ui.store.ts'

const { isLoading } = storeToRefs(useUiStore())
</script>

<style scoped>
.global-loading-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  z-index: 50;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.15);
}

.global-loading-bar-indicator {
  position: absolute;
  height: 100%;
  border-radius: 9999px;
  background: var(--atsume-main);
  animation:
    loading-slide-width 2s infinite,
    loading-slide-position 2s infinite;
}

@keyframes loading-slide-width {
  0% {
    width: 20%;
  }
  33% {
    width: 50%;
  }
  66% {
    width: 50%;
  }
  100% {
    width: 20%;
  }
}

@keyframes loading-slide-position {
  0% {
    left: -20%;
  }
  100% {
    left: 110%;
  }
}

/* Fade in/out */
.loading-bar-enter-active {
  transition: opacity 0.2s ease;
}

.loading-bar-leave-active {
  transition: opacity 0.4s ease;
}

.loading-bar-enter-from,
.loading-bar-leave-to {
  opacity: 0;
}
</style>
